import React, { useState, useEffect } from "react";
import { getPropertiesFacets, getSearchPayload, getSearchResults } from "services";
import SearchForm from "./SearchForm";
import {useRouter} from "next/router"
import { useContext } from "react";
import { Context } from "services";

export default function SearchComponent() {
  const [propertyType, setPropertyType] = useState([]);
  const [activeItem, setActiveItem] = useState<any>({});
  const [propertiesFacetsWithoutFilter, setPropertiesFacetsWithoutFilter] =
    useState<any>();
  const [propertiesList , setPropertiesList] = useState<any>([])
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  
  useEffect(() => {
    getPropertyType()
  }, [ searchForm.value.asset_type, searchForm.value.sub_asset_type,searchForm.value.state]);
 

  const getPropertyType = async () => {
    const payload =  getSearchPayload(searchForm, router);
    const response:any = await getSearchResults({searches:payload})
    const propertiesFacetList = response.results[1].facet_counts[0].counts;
    setPropertiesList(response.results);
    
    const filteredData = propertiesFacetList.map((item: any) => {
      return { value: item.parent.asset_type_slug, label: item.parent.asset_type_name, count: item.count };
    });

    setPropertyType(filteredData);
    if(searchForm.value.asset_type){
      setActiveItem(searchForm.value.asset_type);
    }
    else{
      searchForm.setField('asset_type',filteredData[0])
      setActiveItem(filteredData[0])
    }
    
  };

  let activeClass =
    "w-full lg:w-[initial] cursor-pointer border-indigo-500 text-blue-600 bg-blue-50 lg:bg-transparent inline-flex items-center lg:pt-1 border-b-2 text-sm font-medium lg:-mb-0.5 capitalize shadow-inner lg:shadow-none border-gray-200 ";

  let inactiveClass =
    "w-full lg:w-[initial] cursor-pointer text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center lg:pt-1 border-b-2 text-sm font-medium lg:-mb-0.5 capitalize shadow-inner lg:shadow-none  border-gray-200";
  return (
    <div className="max-w-5xl mx-auto">
      {/* web */}
      <div className="hidden lg:flex justify-center lg:justify-between h-16">
        <div className="flex px-2 lg:px-0">
          <div className="grid grid-cols-2 gap-2 lg:flex lg:space-x-8 lg:border-gray-300 lg:border-b-2">
            {propertyType.map((item: any, index: number) => {
              return (
                <div
                  key={index}
                  onClick={() => {setActiveItem(item) ;
                    searchForm.setField('asset_type',item)
                  }
                  }
                  className={
                    activeItem.value === item.value
                      ? activeClass
                      : inactiveClass
                  }
                >
                  {item.label}
                  <span
                    className={
                      activeItem.value === item.value
                        ? "text-red-400 text-xs ml-1"
                        : "text-gray-900 text-xs ml-1"
                    }
                  >
                    ({item.count})
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex-1 flex justify-center items-center lg:px-2 lg:px-2 mt-4 lg:pt-4 pb-4 lg:pb-6 shadow-lg border border-gray-200 rounded-lg bg-white">
        <div className="hidden lg:block">
          <SearchForm
            propertiesFacetsWithoutFilter={propertiesFacetsWithoutFilter}
            propertyType={false}
            assetType={activeItem}
            widthClass=""
            urlData={{}}
            propertiesList={propertiesList}

          />
        </div>
        {/* mobile */}
        <div className="lg:hidden w-full">
          {/* Buttons */}
          <div className="flex w-full justify-center h-auto lg:h-[initial] bg-white rounded-lg">
            <div className="flex w-full lg:px-2">
              <div className="grid grid-cols-2 gap-0 w-full border-b border-gray-200	place-items-center">
                {propertyType.map((item: any, index: number) => {
                  return (
                    <div
                      key={index}
                      onClick={() => setActiveItem(item)}
                      className={`${
                        activeItem.value === item.value
                          ? activeClass
                          : inactiveClass
                      }  py-4 align-center justify-center`}
                    >
                      {item.label}
                      <span
                        className={
                          activeItem.value === item.value
                            ? "text-red-400 text-xs ml-1"
                            : "text-gray-900 text-xs ml-1"
                        }
                      >
                        ({item.count})
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {propertiesList ? (
            <SearchForm
              propertiesFacetsWithoutFilter={propertiesFacetsWithoutFilter}
              propertyType={true}
              assetType={activeItem}
              widthClass=""
              urlData={{}}
              propertiesList={propertiesList}
            />
          ) : (
            <div className="flex flex-col justify-center items-center w-full pt-6">
              <div className="animate-pulse w-full">
                <div className="bg-gray-400 animate-pulse h-4 w-1/2 mb-2"></div>
                <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
              </div>
              <div className="animate-pulse w-full">
                <div className="bg-gray-400 animate-pulse h-4 w-1/2 mb-2"></div>
                <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
